import { render, staticRenderFns } from "./ColorPickerSelect.vue?vue&type=template&id=52886d5e&scoped=true"
import script from "./ColorPickerSelect.vue?vue&type=script&lang=js"
export * from "./ColorPickerSelect.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerSelect.vue?vue&type=style&index=0&id=52886d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52886d5e",
  null
  
)

export default component.exports